import { environment } from '../../../environments/environment';
import {PaginationCriteria} from "../requests/PaginationCriteria";

export class EndpointService {

  constructor() {
  }

  // register & login
  public static register = `${environment.apiUrl}/api/auth/register`;

  public static login = `${environment.apiUrl}/api/auth/login`;

  public static verifyTwoFactor = `${environment.apiUrl}/api/auth/verify-2fa`;

  public static resendTwoFactorCode = `${environment.apiUrl}/api/auth/resend-2fa-token`;

  public static companyLogin = `${environment.apiUrl}/api/companies/`;

  public static getSSOLoginLink = (subDomain, hint, redirectUri, isIos: boolean, loginHint?: string) => {
    let url = `${environment.sso.authorizationUrl}?nonce=defaultNonce&response_type=id_token`;

    const promptExcludedHints = ['3pillarglobal', 'deloitte'];
    if (!promptExcludedHints.includes(hint)) {
      url += `&prompt=login`;
    }

    const scope =
      hint === 'pepsico'
        ? 'openid email profile'
        : 'openid';

    if (isIos) {
      redirectUri = 'mybenefits://auth/sso';
    }

    url = url + `&scope=${encodeURIComponent(scope)}`;
    url = url + `&p=${environment.sso.policyId}`;
    url = url + `&client_id=${environment.sso.clientId}`;
    url = url + `&redirect_uri=${redirectUri}`;
    url = url + `&domain_hint=${hint}`;
    if (loginHint && promptExcludedHints.includes(hint)) {
      url = url + `&login_hint=${encodeURIComponent(loginHint)}`;
    }
    url = url + `&state=${JSON.stringify({subDomain})}`;
    return url;
  };

  public static tokenExchange = `${environment.apiUrl}/api/auth/tokens/exchange`;

  public static logout = `${environment.apiUrl}/api/auth/logout`;

  public static refresh = `${environment.apiUrl}/api/auth/refresh-token`;

  public static forgotPassword = `${environment.apiUrl}/api/auth/forgot-password`;

  public static resetPassword = `${environment.apiUrl}/api/auth/reset-password`;

  public static changePassword = `${environment.apiUrl}/api/auth/change-password`;

  public static timeSpentOnPlatform = `${environment.apiUrl}/api/User/time-spent-on-platform`;

  // custom-register
  public static getCustomFields = `${environment.apiUrl}/api/customfield/get-custom-fields`;

  public static addUserCustomField = `${environment.apiUrl}/api/usercustomfield`;

  public static checkUserCustomFieldRegister = `${environment.apiUrl}/api/usercustomfield/check-if-user-custom-field-registered`;
  // user
  public static getUserProfileInfo = `${environment.apiUrl}/api/User`;

  public static getUserAddresses = `${environment.apiUrl}/api/address/get-addresses`;

  public static addUserAddress = `${environment.apiUrl}/api/address`;

  public static editUserAddress = `${environment.apiUrl}/api/address`;

  public static deleteUserAddress = `${environment.apiUrl}/api/address`;

  public static editUser = `${environment.apiUrl}/api/User`;

  public static getUserCompanyInfo = (subDomain: string)  => `${environment.apiUrl}/api/companies/${subDomain}/info`;

  public static getUserAuthType = (subDomain: string, email: string)  => `${environment.apiUrl}/api/companies/${subDomain}/users-by-email/${email}/authType`;

  // picture
  public static changeProfilePicture = `${environment.apiUrl}/api/User/change-profile-picture`;

  public static deleteProfilePicture = `${environment.apiUrl}/api/User/delete-profile-picture`;

  // benefit summary
  public static getBenefit = `${environment.apiUrl}/api/benefit/`;
  public static getBenefitCheckoutPolicy = (benefitId: number) => `${environment.apiUrl}/api/benefit/${benefitId}/checkout-policy`;

  public static getBeneficiaries = `${environment.apiUrl}/api/beneficiary/get-beneficiaries`;

  public static getBeneficiary = `${environment.apiUrl}/api/beneficiary/`;

  public static addBeneficiary = `${environment.apiUrl}/api/beneficiary`;

  public static editBeneficiary = `${environment.apiUrl}/api/beneficiary`;

  public static deleteBeneficiary = `${environment.apiUrl}/api/beneficiary`;

  public static getBenefitDocuments = `${environment.apiUrl}/api/benefit-document/get-documents`;

  public static getFixedBenefitDocuments = `${environment.apiUrl}/api/fixed-benefit-documents/get-company-fixed-benefit-document`;

  public static getCardInfo = `${environment.apiUrl}/api/card-info/get-stored-cards`;


  // benefit details
  public static getBenefitDetails = `${environment.apiUrl}/api/benefit/get-benefit-detail`;

  public static getOrderDetails = (userId: string, orderId: number) => `${environment.apiUrl}/api/users/${userId}/orders/${orderId}/details`;
  public static getSubscriptionDetails = (userId: string, subscriptionId: number) => `${environment.apiUrl}/api/users/${userId}/subscriptions/${subscriptionId}/details`;
  public static getAutoOrderDetails = (userId: string, autoOrderId: number) => `${environment.apiUrl}/api/users/${userId}/auto-orders/${autoOrderId}/details`;
  public static getSubscriptionPayments = (subscriptionId: number) => `${environment.apiUrl}/api/subscriptions/${subscriptionId}/payments`;
  public static updateSubscriptionDynamicAttribute = (userId: string, subscriptionId: number) =>
  `${environment.apiUrl}/api/users/${userId}/subscriptions/${subscriptionId}/dynamic-attributes`;

  // support message
  public static addSupportMessage = `${environment.apiUrl}/api/suport-message/add-support-message`;

  // benefits
  public static getUserProvidersCardInfo = `${environment.apiUrl}/api/benefit/get-providers-card-info`;

  public static getOfferBenefits = `${environment.apiUrl}/api/benefit/get-offer-benefits`;

  public static getUserFlexibleBenefits = `${environment.apiUrl}/api/benefit/get-benefits`;

  public static getUserFixedBenefits = `${environment.apiUrl}/api/company-fixed-benefit/get-company-fixed-benefits`;

  public static getBenefitPhotos = `${environment.apiUrl}/api/photo/get-photos`;

  public static getUserFixedBenefitDetails = `${environment.apiUrl}/api/company-fixed-benefit/id`;

  public static getUserFlexibleBenefitDetails = `${environment.apiUrl}/api/benefit`;

  public static getUserFixedBenefitDiscounts = 'https://discount.ro/mybenefits/y34g45vg45g34g43gg3.php';

  public static addFixedBenefitExpenseReport = `${environment.apiUrl}/api/expense-reports`;

  public static getUserExpenseReports = (userId: string) => `${environment.apiUrl}/api/users/${userId}/expense-reports`;

  public static getUserExpenseReportFile = (userId: string, reportId: string, fileId: string) =>
    `${environment.apiUrl}/api/users/${userId}/expense-reports/${reportId}/files/${fileId}`;

  // dashboard
  public static getUserInfoDashboard = `${environment.apiUrl}/api/User/get-user-info-dashboard`;

  public static getChartInfo = `${environment.apiUrl}/api/order/get-chart-info`;

  public static top5BenefitsOrders = `${environment.apiUrl}/api/order/top-5-benefits-orders`;

  public static ordersOnCategories = `${environment.apiUrl}/api/order/orders-on-categories`;
  // admin
  public static getMostPopularBenefits = `${environment.apiUrl}/api/benefit/get-most-popular-benefits`;

  public static getMostPopularCategories = `${environment.apiUrl}/api/benefit/get-most-popular-categories`;

  public static getCompanyStatistics = `${environment.apiUrl}/api/company/get-company-statistics`;

  public static getCompanyBudgetChart = `${environment.apiUrl}/api/company/get-company-budget-chart`;

  public static exportTaxReport = `${environment.apiUrl}/api/order/get-tax-order-reports`;

  // category
  public static getFilteredCategories = `${environment.apiUrl}/api/category/get-filtered-categories`;

  public static getMappedBenefits = `${environment.apiUrl}/api/companyBenefit/get-mapped-benefits`;

  // orders
  public static getAllOrdersHistory = (userId: string, pagination: PaginationCriteria) => `${environment.apiUrl}/api/users/${userId}/orders?paginationCriteria.start=${pagination.start}&paginationCriteria.limit=${pagination.limit}`;
  public static getAllOrdersHistoryMinimal = (userId: string, minimalData: boolean, pagination: PaginationCriteria) => `${environment.apiUrl}/api/users/${userId}/orders?paginationCriteria.start=${pagination.start}&paginationCriteria.limit=${pagination.limit}&minimalData=${minimalData}`;
  public static getAllSubscriptionsHistory = (userId: string, pagination: PaginationCriteria) => `${environment.apiUrl}/api/users/${userId}/subscriptions?paginationCriteria.start=${pagination.start}&paginationCriteria.limit=${pagination.limit}`;
  public static getAllAutoOrdersHistory = (userId: string, pagination: PaginationCriteria) => `${environment.apiUrl}/api/users/${userId}/auto-orders?paginationCriteria.start=${pagination.start}&paginationCriteria.limit=${pagination.limit}`;

  public static getAllInsuranceOrdersHistory = (userId: string) => `${environment.apiUrl}/api/users/${userId}/insurance-orders`;
  public static getInsuranceOrderDetails = (userId: string, orderId: number) => `${environment.apiUrl}/api/users/${userId}/insurance-orders/${orderId}`;
  public static syncInsuranceOrders = (userId: string) => `${environment.apiUrl}/api/users/${userId}/insurance-orders/sync`;

  public static postSimpleOrder = `${environment.apiUrl}/api/order/simple-payment`;

  public static postDirectOrder = `${environment.apiUrl}/api/order/direct-payment`;

  public static returnPaymentInfo = `${environment.apiUrl}/api/payment/return`;

  public static getTaxForBenefit = `${environment.apiUrl}/api/benefit/get-benefit-taxes`;

  public static cancelOrderRequest = `${environment.apiUrl}/api/order/cancel-order-request`;

  public static retrySimpleOrder = `${environment.apiUrl}/api/order/retry-simple-payment`;

  public static retryDirectOrder = `${environment.apiUrl}/api/order/retry-direct-payment`;

  public static getOrderPayment = `${environment.apiUrl}/api/order/payment-retry`;

  public static retrySimpleSubscription = `${environment.apiUrl}/api/subscription/simple-subscription-payment`;

  public static retryDirectSubscription = `${environment.apiUrl}/api/subscription/direct-subscription-payment`;

  public static userCanOrder = `${environment.apiUrl}/api/order/user-can-order`;

  // subscription

  public static getSubscriptionFuturePayments = `${environment.apiUrl}/api/subscription/get-future-payments`;

  public static getSubsriptionPayments = `${environment.apiUrl}/api/subscription/get-payments`;

  // auto-order
  public static updateAutoOrderStatus = `${environment.apiUrl}/api/auto-order/update-auto-order-status`;

  // provider
  public static getProviderById = (id: number) => `${environment.apiUrl}/api/provider/${id}`;

  // balance
  public static getUserBalance = `${environment.apiUrl}/api/balance/get-last-user-balance`;
  public static getUserBalanceHistory = `${environment.apiUrl}/api/balance-history/get-last-history`;
  public static getUserOrderedTicketsBalanceHistory = `${environment.apiUrl}/api/balance-history/get-ordered-tickets`;
  public static getUserLastManualBalance = `${environment.apiUrl}/api/balance-history/get-last-manual-load`;

  // gift Tickets
  public static getGiftTicketInfoByCompany = `${environment.apiUrl}/api/giftTicket/get-by-company`;
  public static getGiftTicketInfoByCompanyForClient = `${environment.apiUrl}/api/giftTicket/get-gift-ticket-for-client`;
  public static giftTicketBase = `${environment.apiUrl}/api/giftTicket/`;
  public static getByBenefit = `${environment.apiUrl}/api/giftTicket/get-by-benefit`;

  // featureFlags
  public static getFeatureFlag = `${environment.apiUrl}/api/featureFlag/`;

  // cashback
  public static getCashbackShopList = `${environment.apiUrl}/api/cashback`;
  public static getCashbackPendingAmount = `${environment.apiUrl}/api/cashback/pending`;
  public static getCashbackShopDetails = (shopId) => `${environment.apiUrl}/api/cashback/${shopId}`;
  public static getCashbackLink = (shopId) => `${environment.apiUrl}/api/cashback/${shopId}/links`;
  public static mobileAppEndpoint = `${environment.apiUrl}/api/version/mobile`;

  public static cnpSignUpCheck = `${environment.apiUrl}/api/auth/signup/user-by-cnp`;
  public static completeSignUp = `${environment.apiUrl}/api/auth/signup/set-email`;

  public static getActiveCompanyEvents = (subDomain: string)  => `${environment.apiUrl}/api/companies/${subDomain}/events`;
  public static getActiveCompanyEvent = (subDomain: string, eventId: number)  => `${environment.apiUrl}/api/companies/${subDomain}/events/${eventId}`;
  public static recordConsent = (userId) => `${environment.apiUrl}/api/users/${userId}/consents`
  public static getMissingConsents = (userId) => `${environment.apiUrl}/api/users/${userId}/consents/missing`
  public static getLatestConsents = `${environment.apiUrl}/api/consents/latest`

  public static getNthWorkingDay = `${environment.apiUrl}/api/utils/working-days/get-nth-day`;

  public static notificationEndpoint = `${environment.apiUrl}/api/notifications`;

  //auto-order

  public static getAutoOrder = `${environment.apiUrl}/api/auto-orders`;
  public static getAutoOrderPayments = (autoOrderId: number) => `${environment.apiUrl}/api/auto-orders/${autoOrderId}`;
  public static updateAutoOrder= (autoOrderId: number) => `${environment.apiUrl}/api/auto-orders/${autoOrderId}`;
  public static createAutoOrder = `${environment.apiUrl}/api/auto-orders`;

  // raiffeisen
  public static getRaiffeisenBranches = `${environment.apiUrl}/api/raiffeisen-benefit/get-branches/`;
}
